<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-simple-table class="elevation-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center">Acción</th>
            <th class="text-left">Descripción</th>
            <th class="text-center">Numero de Documentos</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in requestService.items" :key="service.id">
            <td class="px-0" style="width: 15%">
              <v-menu :close-on-content-click="true">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="blue darken-3" fab x-small outlined>
                    <v-icon color="white"> mdi-dots-vertical </v-icon>
                  </v-btn>
                </template>
                <v-list rounded>
                  <v-list-item>
                    <v-list-item-title
                      icon
                      @click="
                        openModalFilesUploadService(requestService.id, service)
                      "
                      color="primary"
                      x-small
                      class="pointer"
                    >
                      <v-badge
                        bordered
                        :color="service.documents.length ? 'green' : 'red'"
                        :content="
                          service.documents.length
                            ? service.documents.length
                            : '0'
                        "
                        overlap
                      >
                        <v-icon class=""> mdi-file-multiple-outline </v-icon>
                      </v-badge>
                      <span class="mx-3"> Documentos </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td class="w-50">
              <p class="text-left my-0">
                {{ service.name ? service.name : "-" }}
              </p>
            </td>
            <td>
              <p class="text-center my-0">
                {{ service.documents.length ? service.documents.length : "-" }}
              </p>
            </td>
          </tr>
          <tr v-if="requestService.items.length == 0">
            <td colspan="10" class="bg-white">
              <small>
                Sin Servicios {{ deletedItems ? "Eliminados" : "" }}
              </small>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <modal-files-service-quote
      ref="modalFilesUploadServiceQuote"
      :modalAction="dialogFilesUploadService"
      :closeModalFilesService="closeModalFilesUploadService"
      :userCreateRequestQuote="false"
      :currentService="currentFilesUploadService"
      :currentRequest="requestService"
      :requestId="currentRequestQuoteId"
      :requestingUserModule="requestingUserModule"
      :typeRequestService="requestService ? requestService.request_type : null"
      @filesUploaded="getQuoteByIdAndSyncCurrentService"
      @updateDocumentsCurrentService="getQuoteByIdAndSyncCurrentService"
    >
    </modal-files-service-quote>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import exchangeRateMixin from "@/mixins/exchangeRate";
import QUOTE_CONSTANTS from "@/constants/quotes";
import ModalFilesServiceQuote from "./ModalFilesServiceQuote.vue";
export default {
  mixins: [exchangeRateMixin],
  props: {
    requestService: {
      type: Object,
      required: true,
    },
    requestingUserModule: {
      type: Boolean,
      default: false,
    },
    deletedItems: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalFilesServiceQuote,
  },
  data() {
    return {
      loading: false,
      QUOTE_CONSTANTS,
      currentRequestQuoteId: null,
      dialogCommmentsService: false,
      currentServiceComments: null,
      dialogFilesUploadService: false,
      currentFilesUploadService: null,
    };
  },
  methods: {
    ...mapActions({
      getQuoteById: "quote/getQuoteById",
    }),
    async getQuoteByIdAndSyncCurrentService() {
      try {
        let response = await this.getQuoteById({
          quotation_id: this.currentFilesUploadService.id,
        });
        if (response && response.data) {
          console.log("Actualizando servicio", response.data);
          let requestServiceUpdated = response.data;
          requestServiceUpdated.documents = await this.mapExchangeRate(
            requestServiceUpdated.documents
          );
          this.currentFilesUploadService = requestServiceUpdated;
          this.$refs.modalFilesUploadServiceQuote.loadingDocument = false;
          this.$emit("updateIndexQuotesTable");
        } else {
          this.$refs.modalFilesUploadServiceQuote.loadingDocument = false;
          console.log("No se pudo actualizar el servicio");
        }
      } catch (error) {
        console.log(error);
      }
    },
    getPriceItem(quote) {
      try {
        if (quote.documents.length == 1) {
          return {
            price: quote.documents[0].price,
            coin: quote.documents[0].coin,
          };
        }
        let quoteSelected = quote.documents.find((item) => item.selected);
        if (!quoteSelected) {
          return null;
        }
        return {
          price: quoteSelected.price,
          coin: quoteSelected.coin,
        };
      } catch (error) {
        console.log(error);
      }
    },
    getStatusCorrection(status) {
      return QUOTE_CONSTANTS.getStatusCorrection(status);
    },
    openModalCommentsService(requestId, item) {
      this.currentRequestQuoteId = requestId;
      this.currentServiceComments = item;
      this.dialogCommmentsService = true;
    },
    closeModalCommentsService() {
      this.currentServiceComments = null;
      this.dialogCommmentsService = false;
    },
    async openModalFilesUploadService(requestId, item) {
      this.currentRequestQuoteId = requestId;
      this.loading = true;
      let serviceUpdated = {
        ...item,
        documents: await this.mapExchangeRate(item.documents),
      };
      this.loading = false;
      this.currentFilesUploadService = serviceUpdated;
      this.dialogFilesUploadService = true;
    },
    closeModalFilesUploadService() {
      this.currentFilesUploadService = null;
      this.dialogFilesUploadService = false;
    },
    emitGetRequestsQuotes() {
      this.$emit("getRequestsService");
    },
    emitGetRequestsQuotesAndUpdateFiles() {
      this.$emit("getRequestsServiceAndUpdateCurrentService");
    },
    getStatusColor(status) {
      return QUOTE_CONSTANTS.getStatusColor(status);
    },
    async updateFilesCurrentService() {
      let serviceUpdated = null;
      let requestServiceIndex = this.requestServicesQuotes.items.findIndex(
        (item) => item.id == this.currentRequestQuoteId
      );
      if (this.currentFilesUploadService && this.currentFilesUploadService.id) {
        serviceUpdated = this.requestServicesQuotes.items[
          requestServiceIndex
        ].items.find((item) => item.id == this.currentFilesUploadService.id);
        serviceUpdated.documents = await this.mapExchangeRate(
          serviceUpdated.documents
        );
        this.currentFilesUploadService = serviceUpdated;
      }
      this.$refs.modalFilesUploadServiceQuote.loadingDocument = false;
    },
    serviceIsStatusReady(service) {
      return (
        service.status === QUOTE_CONSTANTS.quote_statuses_list.quotation_ready
      );
    },
    serviceIsStatusInReviewOrInQuotation(service) {
      return (
        service.status === QUOTE_CONSTANTS.quote_statuses_list.in_review ||
        service.status === QUOTE_CONSTANTS.quote_statuses_list.in_quotation
      );
    },
    requestIsStatusInUserValidationVariant(request) {
      return (
        request.status ===
        QUOTE_CONSTANTS.quote_statuses_list.user_validation_variant
      );
    },
    requestIsStatusInQuotation(request) {
      return (
        request.status === QUOTE_CONSTANTS.quote_statuses_list.in_quotation
      );
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      requestServicesQuotes: "quote/quotes",
    }),
  },
};
</script>

<style></style>
